<template>
  <div class="row">
    <div class="col-12 grid-force-newlines">
      <FormMultiSelect :placeholder="placeholder" :options="options" :value="value" @input="$emit('update', $event)" />
    </div>
  </div>
</template>

<script>
import FormMixin from '@/mixins/form'

export default {
  name: 'ReportMultiSelect',
  model: {
    prop: 'value',
    event: 'update'
  },
  mixins: [FormMixin],
  props: {
    options: {
      type: Array,
      default: () => ([])
    },
    label: String,
    value: {
      type: Array,
      default: () => ([])
    },
    placeholder: String
  },
  watch: {
    
  },
  data() {
    return {
    }    
  },
  mounted() {
  },
  methods: {
  }
}
</script>